import { Map } from 'immutable';

import { parseTagsFromInput, tagsFromArray } from '@/utils/tags';
import { updateListingScore } from '@/utils/product/score';
import { getTagsError } from '@/utils/validations/tags';
import { clearErrors } from '@/utils/errors';
import { keepOld } from '@/utils/iterable/keepOld';
import { getSize } from '@/utils/iterable/getSize';

import { MAX_NUMBER_OF_TAGS } from '@/constants/validations';
import { OPERATIONS } from '@/constants/bulkEdit';
import { ATTRIBUTE } from '@/constants/attributes';
import { VALUE } from '@/constants/product';
import { FORM } from '@/constants/forms';

export default function tags({ actions, operation, product, shop, userFeatures }) {
  const channel = product.get('channel');

  function setValueToProduct(value) {
    let result = product.set(FORM.TAGS, Map({ [VALUE]: value }));

    if (operation.hasIn(['ai', 'original'])) {
      result = result.setIn([FORM.TAGS, 'ai'], operation.get('ai'));
    }

    if (result.hasIn(['score', ATTRIBUTE.TAGS])) {
      result = updateListingScore({ product: result, shop, userFeatures });
    }

    return result;
  }

  function validateAndApply(value) {
    return {
      actions,
      product: getTagsError({ channel, tags: value })
        ? product
        : clearErrors({ errors: [ATTRIBUTE.TAGS], product: setValueToProduct(value) }),
    };
  }

  switch (operation.get('type')) {
    case OPERATIONS[channel].TAGS.ADD: {
      const productValue = product.getIn([FORM.TAGS, 'value']);

      if (getSize(productValue) >= MAX_NUMBER_OF_TAGS[channel]) break;

      const operationValue = parseTagsFromInput({
        channel,
        tags: productValue,
        value: operation.get('value'),
      });

      return validateAndApply(productValue.mergeWith(keepOld, operationValue));
    }

    case OPERATIONS[channel].TAGS.DELETE: {
      const operationValue = parseTagsFromInput({ channel, value: operation.get('value') });
      const value = product.getIn([FORM.TAGS, 'value']).deleteAll(operationValue.keySeq());
      return validateAndApply(value);
    }

    case OPERATIONS[channel].TAGS.CHANGE_TO: {
      const value = tagsFromArray(operation.get('value'));
      return validateAndApply(value);
    }

    default: {
      break;
    }
  }

  return { actions, product };
}
